export const GET_ALL_ACTIVITY = `
  query {
    getActivity {
        id
        description
        entity_type
        status
    }
  }  
`;